import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "remove",
  "use": "remove-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 9\" id=\"remove\"><path d=\"M7.016 8.076L4.364 5.425 1.712 8.076l-1.06-1.06 2.651-2.652L.652 1.712l1.06-1.06 2.652 2.651L7.016.652l1.06 1.06-2.651 2.652 2.651 2.652z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol